import { LanguageActionType } from '../../types/languguageReduserType'

export const setLanguage = (value: string) => {
    return {type: LanguageActionType.CHANGE_VALUE_LANGUAGE, payload: value}
}